import { SocieteLinkedModel } from "./societe-linked.model";

export class Ca2Model extends SocieteLinkedModel {
    // max 30
    imputable: string;
    // max 15
    codeCa1: string;
}
